var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackingDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30853 16.9862C12.8972 16.9862 16.6171 13.349 16.6171 8.86234C16.6171 4.37568 12.8972 0.738525 8.30853 0.738525C3.71985 0.738525 0 4.37568 0 8.86234C0 13.349 3.71985 16.9862 8.30853 16.9862Z",
    fill: "#E4DCF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30833 11.5702C9.83788 11.5702 11.0778 10.3578 11.0778 8.86224C11.0778 7.36668 9.83788 6.1543 8.30833 6.1543C6.77877 6.1543 5.53882 7.36668 5.53882 8.86224C5.53882 10.3578 6.77877 11.5702 8.30833 11.5702Z",
    fill: "#492897"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingDots);
export default __webpack_public_path__ + "static/media/tracking-dots.cf80e49fc011055af1deb375a8c6ff42.svg";
export { ForwardRef as ReactComponent };